import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { connect } from 'react-redux';
import howItWorksArrowRed from 'images/how-it-works-arrow-red.png';
import howItWorksArrowBlue from 'images/how-it-works-arrow-blue.png';
import howItWorksArrowBlueMobile from 'images/how-it-works-arrow-blue-mobile.png';
import howItWorksArrowRedMobile from 'images/how-it-works-arrow-red-mobile.png';
import { withTranslation } from 'react-i18next';

import './styles.scss';

import StepGraphic from './StepGraphic';

const howItWorksSteps = ({ selectedStep = 1 }) => {
    return (
        <div className='how-it-works-steps-container'>
            <StepGraphic
                isFillCircle={ selectedStep > 1 }
                selectedStep={ selectedStep }
                stepNumber={ 1 }
                stepName={ i18n.t('motivator.motivation') }
                stepDescription={
                    i18n.t('motivator.ten_minute_intrinsic_motivation_survey')
                } />
            <div className='arrow-container'>
                <img src={ selectedStep > 1 ? howItWorksArrowBlue : howItWorksArrowRed } alt='how-it-works-arrow' />
            </div>
            <div className='arrow-container-mobile'>
                <img src={ selectedStep > 1 ? howItWorksArrowBlueMobile : howItWorksArrowRedMobile } alt='how-it-works-arrow' />
            </div>
            <StepGraphic
                isFillCircle={ selectedStep > 2 }
                selectedStep={ selectedStep }
                stepNumber={ 2 }
                stepName={ i18n.t('motivator.engagement') }
                stepDescription={ i18n.t('motivator.quick_pulse_survey') } />
            <div className='arrow-container'>
                <img src={ selectedStep > 2 ? howItWorksArrowBlue : howItWorksArrowRed } alt='how-it-works-arrow' />
            </div>
            <div className='arrow-container-mobile'>
                <img src={ selectedStep > 2 ? howItWorksArrowBlueMobile : howItWorksArrowRedMobile } alt='how-it-works-arrow' />
            </div>

            <StepGraphic
                isFillCircle={ false }
                selectedStep={ selectedStep }
                stepNumber={ 3 }
                stepName={ i18n.t('motivator.report') }
                stepDescription={
                    i18n.t('motivator.get_your_unique_intrinsic_motivation_report')
                } />
        </div>
    );
};

howItWorksSteps.defaultProps = {
    selectedStep: 'motivation',
    respondent: {}
};

howItWorksSteps.propTypes = {
    selectedStep: PropTypes.number
};

const mapStateToProps = state => ({
    respondent: state.respondentNameReducer
});

export default withTranslation()(connect(mapStateToProps)(howItWorksSteps));

